export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./PageDivider.vue?vue&type=template&id=65d27d48&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/PageDivider.vue?vue&type=template&id=65d27d48&scoped=true&
// module id = 241
// module chunks = 0